import { render } from "./GeoErrorModal.vue?vue&type=template&id=fbb4b6e4"
import script from "./GeoErrorModal.vue?vue&type=script&lang=js"
export * from "./GeoErrorModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnny/express-vue3-tailwind-map/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__